export type CameraFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type CameraFilterGroup = {
  id: string;
  label: string;
  options: CameraFilterOption[];
};

export const cameraFilterGroups: CameraFilterGroup[] = [
  {
    id: 'camera-type',
    label: 'Loại camera',
    options: [
      { value: 'indoor', label: 'Camera trong nhà', keywords: ['trong nha', 'indoor'] },
      { value: 'outdoor', label: 'Camera ngoài trời', keywords: ['ngoai troi', 'outdoor'] },
      { value: 'ai', label: 'Camera AI', keywords: ['camera ai', 'ai camera'] },
      { value: 'dashcam', label: 'Camera hành trình', keywords: ['hanh trinh', 'dashcam'] },
    ],
  },
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: 'imou', label: 'IMOU', keywords: ['imou'] },
      { value: 'ezviz', label: 'EZVIZ', keywords: ['ezviz'] },
      { value: 'tp-link', label: 'TP-Link', keywords: ['tp-link', 'tplink', 'tapo'] },
      { value: 'ithink', label: 'iThink', keywords: ['ithink'] },
      { value: 'hilook', label: 'HiLook', keywords: ['hilook'] },
      { value: 'tiandy', label: 'Tiandy', keywords: ['tiandy'] },
      { value: 'skyworth', label: 'Skyworth', keywords: ['skyworth'] },
      { value: 'hikvision', label: 'HIKVISION', keywords: ['hikvision'] },
      { value: 'dahua', label: 'Dahua', keywords: ['dahua'] },
      { value: 't-vision', label: 'T-Vision', keywords: ['t-vision', 'tvision'] },
    ],
  },
  {
    id: 'resolution',
    label: 'Độ phân giải',
    options: [
      { value: '1mp', label: '1MP', keywords: ['1mp', '1.0mp'] },
      { value: '2mp', label: '2MP', keywords: ['2mp', '2.0mp', '1080p'] },
      { value: '3mp', label: '3MP', keywords: ['3mp', '3.0mp'] },
      { value: '4mp', label: '4MP', keywords: ['4mp', '4.0mp', '2k'] },
      { value: '5mp', label: '5MP', keywords: ['5mp', '5.0mp'] },
      { value: 'above-5mp', label: 'Trên 5MP', keywords: ['6mp', '8mp', '4k'] },
    ],
  },
  {
    id: 'utility',
    label: 'Tiện ích',
    options: [
      {
        value: 'motion-tracking',
        label: 'Theo dõi chuyển động',
        keywords: ['theo doi chuyen dong', 'motion tracking'],
      },
      {
        value: 'color-night-vision',
        label: 'Quan sát ban đêm có màu',
        keywords: ['ban dem co mau', 'color night vision'],
      },
      {
        value: 'human-detection',
        label: 'Phát hiện con người',
        keywords: ['phat hien con nguoi', 'human detection'],
      },
      {
        value: 'motion-detection',
        label: 'Phát hiện chuyển động',
        keywords: ['phat hien chuyen dong', 'motion detection'],
      },
      {
        value: 'sound-detection',
        label: 'Phát hiện tiếng khóc/âm thanh bất thường',
        keywords: ['am thanh bat thuong', 'sound detection'],
      },
      { value: 'siren', label: 'Còi báo động', keywords: ['coi bao dong', 'siren'] },
      {
        value: 'phone-alert',
        label: 'Gửi cảnh báo đến điện thoại',
        keywords: ['canh bao dien thoai', 'phone alert'],
      },
      {
        value: '2-way-talk',
        label: 'Đàm thoại 2 chiều',
        keywords: ['dam thoai 2 chieu', '2-way talk', 'talkback'],
      },
    ],
  },
  {
    id: 'quality',
    label: 'Chất lượng hình ảnh',
    options: [
      { value: 'full-hd', label: 'Full HD', keywords: ['full hd', '1080p'] },
      { value: '2k', label: '2K', keywords: ['2k', '1440p'] },
      { value: '3k', label: '3K', keywords: ['3k'] },
      { value: '4k', label: '4K', keywords: ['4k', 'ultra hd'] },
    ],
  },
];
